@if (visible$ | async) {
  <nav aria-label="breadcrumb"></nav>
}
